<template>
  <div class="kefu-page page-padding-top">
    <top-bar :title="i18n.t('kefu.title')" @back="back"></top-bar>

    <!-- 客服iframe组件 -->
    <KefuIframe
      :visible="showIframe"
      :link="currentKefuLink"
      @close="closeKefuIframe" />

    <!-- 客服列表 -->
    <div v-if="!showIframe">
      <div class="flex-column-center top-info">
        <img :src="bgUrl" alt="">
        <div>{{$t('kefu.title1')}}</div>
        <div>{{$t('kefu.title2')}}</div>
      </div>

      <div class="kefu-list">
        <div class="list flex-center" v-for="(item, i) in kefuList" :key="i" @click="chooseKefu(item)">
          <div class="icon">
            <img :src="item.Avatar" alt="">
          </div>
          <div class="flex-1">
            <div class="name">{{item.Name}}</div>
            <div class="status green" >{{$t(`kefu.status1`)}}</div>
          </div>
          <div class="right">
            <img :src="rightUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/utils/sdk.js"
import topBar from '@/components/topBar'
import KefuIframe from '@/components/KefuIframe.vue'
import { customerList } from '@/api/setting'
import { isQiabotNewType, openQiabotWidget, QIABOT_NEW_TYPE } from '@/utils/qiabot'

export default {
  components: {
    topBar,
    KefuIframe
  },
  data() {
    return {
      bgUrl: require('../../assets/imgs/kefu-bg.png'),
      rightUrl: require('../../assets/imgs/icon-arrow-right2.png'),
      kefuUrl: '',
      kefuList: [],
      showIframe: false,
      currentKefuLink: ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    back() {
      // 如果当前显示iframe，先关闭iframe
      if (this.showIframe) {
        this.closeKefuIframe()
        return
      }

      this.$router.go(-1)
      // 如果是chatwoot客服，隐藏气泡
      if(window.$chatwoot) {
        window.$chatwoot.toggleBubbleVisibility('hide');
      }
    },
    init(){
      //客服
      customerList().then(res => {
        this.kefuList = res.data.Items
      })
    },
    chooseKefu(data) {
      this.to(data.Type, data.Link, data.Token)
    },
    // 关闭客服iframe
    closeKefuIframe() {
      this.showIframe = false
      this.currentKefuLink = ''
    },
    to(Type, Link, Token) {
      let tmp = undefined
      let that = this
      if(isQiabotNewType(Type)) {
        window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
        openQiabotWidget(Link).catch(error => {
          console.error('qiabot新版打开失败:', error)
        })
      } else if(Type == "chatwoot") {
        window.localStorage.setItem('kefuType', 'chatwoot')
        if(window.$chatwoot === undefined) {
          // 如果chatwoot还未初始化，先初始化
          this.chatwoot(Link, Token)
          tmp = setInterval(function (){
            if (window.$chatwoot !== undefined) {
              clearInterval(tmp)
              that.$kefu()
            }
          },50)
        } else {
          this.$kefu()
        }
      } else if (Type == 'meiqia') {
        window.localStorage.setItem('kefuType', 'meiqia')

        // 根据链接中是否包含chatlink.html来决定使用iframe还是原生方式
        if (Link && Link.includes('chatlink.html')) {
          // 将客服链接中的域名替换为当前访问的域名
          let kefuLink = Link
          try {
            const currentHost = window.location.host // 获取当前域名（包含端口）
            const linkUrl = new URL(Link)
            linkUrl.host = currentHost // 替换域名
            kefuLink = linkUrl.toString()
            console.log("link:",linkUrl)
          } catch (e) {
            console.error('替换客服链接域名失败:', e)
            // 如果替换失败，使用原链接
            kefuLink = Link
          }

          console.log("kefuLink", kefuLink)

          // 移动端使用全屏页面，PC端使用iframe弹窗
          if (this.isMobile()) {
            // 跳转到全屏客服页面
            this.$router.push({
              name: 'kefuFullscreen',
              query: {
                link: kefuLink
              }
            })
          } else {
            // PC端使用iframe方式
            this.currentKefuLink = kefuLink
            this.showIframe = true
          }
        } else {
          // 使用原生方式
          this.$kefu()
        }
      } else if (Type === 'qiabot') {
        window.localStorage.setItem('kefuType', 'qiabot')
        const match = Link && Link.match(/[?&]tag=([^&]+)/)
        const tag = match ? match[1] : ''
        const qiabotUrl = '/qiabot.html' + (tag ? '?tag=' + tag : '')
        if (this.isMobile()) {
          this.$router.push({
            name: 'kefuFullscreen',
            query: { link: qiabotUrl }
          })
        } else {
          this.currentKefuLink = qiabotUrl
          this.showIframe = true
        }
      } else {
        // 处理其他类型的客服链接
        switch (Type) {
          case "wechat":
            Link = "weixin://" + Link
            break;
          case "qq":
            Link = "mqq://"+ Link
            break;
          case "whatsapp":
            Link = "whatsapp://send?phone="+ Link
            break;
          case "telegram":
            Link = "tg://resolve?domain="+ Link
            break;
          case "facebook":
            Link = "fb://"+ Link
            break;
          case "twitter":
            Link = "twitter://"+ Link
            break;
          case "instagram":
            Link = "instagram://"+ Link
            break;
          case "line":
            Link = "https://line.me/R/"+ Link
            break;
        }
        this.toKefuPath(Link)
      }
    },
    toKefuPath(path) {
      let a = document.createElement('a')
      a.href = path
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    // 检测是否为移动端
    isMobile() {
      const userAgent = navigator.userAgent
      const mobileKeywords = ['Mobile', 'Android', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone']
      return mobileKeywords.some(keyword => userAgent.includes(keyword)) || window.innerWidth <= 768
    },
    chatwoot(Link, Token){
      let that = this;
      if (Link.length === 0) {
        return;
      }
      let len = Link.indexOf("/widget");
      if (len === -1) {
        // 检查链接是否包含 "/"
        if(!Link.includes("/")) {
          // 不包含 "/" 则拼接
          Link = Link + "/"
        }

        // 创建一个新的 <script> 元素
        const script = document.createElement('script');

        // 设置 <script> 的 src 属性
        script.src = Link + "packs/js/sdk.js";

        // 使用 onload 事件处理程序确保脚本加载完成后执行操作
        script.onload = () => {
          console.log('脚本已加载并可用。');
          window.chatwootSDK.run({
            websiteToken: Token,
            baseUrl: Link
          });

          let inter = setInterval(function(){
            if(document.getElementsByClassName("woot-widget-bubble")[0] !== undefined) {
              clearInterval(inter);
              window.$chatwoot.toggleBubbleVisibility('hide');
            }
          },30);
        };

        // 将 <script> 元素添加到页面的 <head> 中
        document.head.appendChild(script);
      } else {
        // 旧版初始化方式
        var BASE_URL=Link.substr(0,len);
        let tokenlen = Link.indexOf("token=");
        let token = Link.substr(tokenlen+6);
        window.chatwootSDK.run({
          websiteToken: token,
          baseUrl: BASE_URL
        });

        let inter = setInterval(function(){
          if(document.getElementsByClassName("woot-widget-bubble")[0] !== undefined) {
            clearInterval(inter);
            window.$chatwoot.toggleBubbleVisibility('hide');
          }
        },50);
      }
    },
  }
}
</script>
